<template>
  <div class="w-full vx-coll-fixed-height">
    <vs-divider position="left" class="text-xl">{{ $t('sections.prosecution.dataForm.title.prosecutionDetail') }}</vs-divider>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.lawyerAcceptedDate") }}</h6>
        <p>{{ _prosecution.lawyerAcceptedDate | convYYYYMMDDToDDMMYYYY }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.lawyerSendInquiryLetterDate") }}</h6>
        <p>{{ _prosecution.lawyerSendInquiryLetterDate | convYYYYMMDDToDDMMYYYY }}</p>
      </div>
    </div>

    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.dateOfFiling") }}</h6>
        <p>{{ _prosecution.dateOfFiling | convYYYYMMDDToDDMMYYYY }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.principle") }}</h6>
        <p>{{ _prosecution.principleFiling | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.interest") }}</h6>
        <p>{{ _prosecution.interestFiling | numberFormat }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.penalty") }}</h6>
        <p>{{ _prosecution.penaltyFiling | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.fee") }}</h6>
        <p>{{ _prosecution.feeFiling | numberFormat }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.expenseDetailAmount") }}</h6>
        <p>{{ _prosecution.expenseDetailAmountFiling | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.collectionFee") }}</h6>
        <p>{{ _prosecution.collectionFeeFiling | numberFormat }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.lawyerFee") }}</h6>
        <p>{{ _prosecution.lawyerFeeFiling | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.claimAmount") }}</h6>
        <p>{{ _prosecution.claimAmount  | numberFormat }}</p>
      </div>
    </div>

    <vs-divider position="left" class="text-xl">{{ $t('sections.prosecution.dataForm.title.expense') }}</vs-divider>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.dateOfCourtFiling") }}</h6>
        <p>{{ _prosecution.dateOfCourtFiling  | convYYYYMMDDToDDMMYYYY }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.court") }}</h6>
        <p>{{ _prosecution.court  || '-' }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.blackCaseNumber") }}</h6>
        <p>{{ _prosecution.blackCaseNumber || '-' }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.courtFee") }}</h6>
        <p>{{ _prosecution.courtFee | numberFormat }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.documentFee") }}</h6>
        <p>{{ _prosecution.documentFee | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.sendOpponentFee") }}</h6>
        <p>{{ _prosecution.sendOpponentFee | numberFormat }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.sendEnforcementFee") }}</h6>
        <p>{{ _prosecution.sendEnforcementFee | numberFormat }}</p>
      </div>
    </div>
    <vs-divider position="left" class="text-xl">{{ $t('sections.prosecution.dataForm.title.judgment') }}</vs-divider>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.redCaseNumber") }}</h6>
        <p>{{ _prosecution.redCaseNumber || '-' }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.dateOfCourtJudgment") }}</h6>
        <p>{{ _prosecution.dateOfCourtJudgment  | convYYYYMMDDToDDMMYYYY }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.prosecutionResult") }}</h6>
        <p>{{ _prosecution.prosecutionResultName || '-' }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-full">
        <h6>{{ $t("sections.prosecution.dataForm.prosecutionResultDescription") }}</h6>
        <p>{{ _prosecution.prosecutionResultDescription || '-' }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-full">
        <h6>{{ $t("sections.prosecution.dataForm.prosecutionReasonDescription") }}</h6>
        <p>{{ _prosecution.prosecutionReasonDescription || '-' }}</p>
      </div>
    </div>

    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.principle") }}</h6>
        <p>{{ _prosecution.principleAfter | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.interest") }}</h6>
        <p>{{ _prosecution.interestAfter | numberFormat }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.penalty") }}</h6>
        <p>{{ _prosecution.penaltyAfter | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.fee") }}</h6>
        <p>{{ _prosecution.feeAfter | numberFormat }}</p>
      </div>
    </div>

    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.expenseDetailAmount") }}</h6>
        <p>{{ _prosecution.expenseDetailAmountAfter | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.collectionFee") }}</h6>
        <p>{{ _prosecution.collectionFeeAfter | numberFormat }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.lawyerFee") }}</h6>
        <p>{{ _prosecution.lawyerFeeAfter | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.attorneyFeeByCourt") }}</h6>
        <p>{{ _prosecution.attorneyFeeByCourt | numberFormat }}</p>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.expenseAmountAfter") }}</h6>
        <p>{{ _prosecution.expenseAmountAfter | numberFormat }}</p>
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <h6>{{ $t("sections.prosecution.dataForm.courtFeeReturn") }}</h6>
        <p>{{ _prosecution.courtFeeReturn | numberFormat }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";

const { mapState: mapProsecutionFields } = createNamespacedHelpers('Prosecution')

export default {
  name: "LawyerJovInfoTab",
  components: {},
  props: {},
  computed: {
    ...mapProsecutionFields(['prosecution']),
    _prosecution() {
      if(!this.prosecution) return null
      return {
        ...this.prosecution
      }
    },
  },
};
</script>

<style scoped>
.vx-coll-fixed-height{
  display:block;
  width:100%;
  height:555px;
  overflow: auto;
}
</style>
